import { Component, Input } from '@angular/core';
import { TransportOrderView } from '../../../../models/transport-order-view.model';
import { LIST_DELIVERY_STATUS } from '../../../../models/delivery-status.model';

@Component({
  selector: 'jhi-bary-transport-status',
  templateUrl: './bary-transport-status.component.html',
  styleUrls: ['./bary-transport-status.component.scss'],
})
export class BaryTransportStatusComponent {
  @Input() public transportOrder!: TransportOrderView;
  public LIST_DELIVERY_STATUS = LIST_DELIVERY_STATUS;
}
